<!--
트래킹검수 > 검수화면 > 검수대상 리스트 컴포넌트 >
상품 리스트 믹스인 : 모든 상품리스트가 공통으로 가져야할 props 처리
------------------------------------
-->

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },

            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 검수대상 상품리스트
             */
            checkProds: {
                type: Array,
                default: null,
            },

            /**
             * 일괄검수용 하우스그룹 배열
             */
            houseGroups: {
                type: Array,
                default: null,
            },

            /**
             * 일괄검수에서
             * 현재 선택된 하우스그룹ID
             */
            activeHouseGroupId: {
                type: Number,
                default: null,
            },

            /**
             * 고가상품 기준가격(현지 currency)
             **/
            expensiveLimit: {
                type: Number,
                default: 200,
            },
        },

        methods: {
            /**
             * 검수도중 예외발생함
             */
            emitCheckException(msg) {
                this.$emit('check:exception', msg);
            },

            /**
             * 상품중 하나의 검수가 끝났음을 알림
             */
            emitCheckOne() {
                this.$emit('check:one');
            },

            /**
             * 패킹할 준비가 되었음을 알림
             */
            emitPacking(house_id) {
                this.$emit('packing', house_id);
            },
        },
    }
</script>